/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

import TurnLeftIcon from '@mui/icons-material/TurnLeft';

import PrimaryMediumButton from 'components/buttons/PrimaryMediumButton';

export const BreadcrumbsContainer = styled(Box)(({theme}) => ({
  margin: theme.spacing(4, 0, 8, 0),
}));

export const PeriodSelectorContainer = styled(Box)(({theme}) => ({
  margin: theme.spacing(4, 0),
  display: 'flex',
  gap: theme.spacing(4),
  flexWrap: 'wrap',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'nowrap',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

export const ToolbarContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
  flexWrap: 'wrap',
  marginBottom: theme.spacing(4),
}));

export const SearchBox = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '300px',
  flexShrink: 0,

  '.MuiFormControl-root .MuiInputBase-root': {
    padding: theme.spacing(2.25, 2.25, 2.25, 10.25),

    '.MuiInputBase-input': {
      padding: theme.spacing(1.75, 1, 1.75, 1.25),
    },
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledSearchIcon = styled(Box)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  position: 'absolute',
  left: theme.spacing(4),
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
}));

export const GoBackButton = styled(PrimaryMediumButton)(({theme}) => ({
  padding: theme.spacing(3, 6),
  borderRadius: theme.spacing(2),
  background: theme.palette.figma_gray_dark_1?.main,
  color: theme.palette.figma_gray_light_1?.main,
  fontSize: 14,
  fontWeight: 400,
  flexShrink: 0,

  '&:hover': {
    background: theme.palette.figma_gray_dark_2?.main,
  },
}));

export const GoBackIcon = styled(TurnLeftIcon)(({theme}) => ({
  marginRight: theme.spacing(2),
  alignSelf: 'start',
}));

export {ResetButton as DownloadExcelButton} from 'components/Table/core/components/FilterBar/styles';
